import type { ReactNode } from "react";

import { cx } from "./cx";

const VARIANTS = {
  /** A shadowed card with room to breathe (domains detail screens, settings tabs). */
  default: "gap-4 rounded-2xl p-[22px] shadow-[0_6px_10px_rgba(26,20,18,0.08)]",
  /** Flat and a little tighter (hosting cards, the WhatsApp and Notifications settings). */
  tight: "gap-3.5 rounded-2xl px-[22px] py-5",
  /** A plain box whose content sets its own spacing (billing screens). */
  compact: "rounded-[14px] px-5 py-[18px]",
} as const;

/** A white card, optionally with a title (+ subtitle) and an action on the right. */
export function Section({
  title,
  subtitle,
  action,
  variant = "default",
  children,
  className,
}: {
  title?: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  variant?: keyof typeof VARIANTS;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <section className={cx("flex flex-col border border-border bg-surface", VARIANTS[variant], className)}>
      {(title || action) && (
        <div className="flex flex-wrap items-start gap-4">
          <div className="flex min-w-0 flex-1 flex-col gap-[3px]">
            {title && <h2 className="text-lg leading-[22px] font-semibold text-fg">{title}</h2>}
            {subtitle && <p className="text-sm text-fg-subtle">{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}
